function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
import _ from 'lodash';
export var OrderFlows = {
    pickup: [
        'open',
        'confirmed',
        'closed'
    ],
    delivery: [
        'open',
        'confirmed',
        'inTransit',
        'closed'
    ]
};
export var MARKETING_CAMPAIGN_PARAMS = [
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'dtm_campaign',
    'dtm_medium',
    'dtm_content',
    'fbclid',
    'gclid'
];
export var SPECIAL_INSTRUCTIONS_MAX_LENGTH = 500;
export var CURBSIDE_PICKUP_SPECIAL_INSTRUCTIONS = 'This order is for Curbside Pickup.\n';
export var DRIVE_THRU_PICKUP_SPECIAL_INSTRUCTIONS = 'This is a drive thru order.\n';
export var DELIVERY_CUSTOMER_ERROR = 'cannot submit multiple orders from same customer to this dispensary on same day';
export var DELIVERY_ADDRESS_ERROR = 'cannot submit multiple orders from same address to this dispensary on same day';
export var PAUSED_ORDERS_CLOSED_ERROR = "We're closed at the moment due to extremely high demand. Stay tuned though, we'll reopen soon!";
export var DELIVERY_ERRORS = {
    CUSTOMER: 'CUSTOMER',
    ADDRESS: 'ADDRESS'
};
export var POSTAL_CODE_ERROR = 'We were unable to verify your card information. Please ensure the postal code entered matches what is on file at your bank for this card.';
export var OrderFilterOptions = [
    {
        name: 'delivery-available',
        key: 'deliveryAvailable',
        label: 'Delivery Available'
    },
    {
        name: 'free-delivery',
        key: 'freeDelivery',
        label: 'Free Delivery'
    },
    {
        name: 'no-delivery-minimum',
        key: 'noDeliveryMinimum',
        label: 'No Delivery Minimum'
    },
    {
        name: 'accepts-credit-cards',
        key: 'acceptsCreditCards',
        label: 'Accepts Credit Cards'
    }
];
export var PAYMENT_CASH = 'cash';
export var PAYMENT_DUTCHIEPAY = 'dutchiePay';
export var PAYMENT_CREDIT_CARD = 'creditCard';
var _obj;
// Order of these keys is important for
// firstValidPaymentOption to work correctly.
// We want to start with in store, then cash
export var paymentMethodsToDisplayNames = (_obj = {
    payInStore: 'In Store',
    inStore: 'In Store'
}, _define_property(_obj, PAYMENT_CASH, 'Cash'), _define_property(_obj, "check", 'Check'), _define_property(_obj, PAYMENT_CREDIT_CARD, 'Credit Card'), _define_property(_obj, "creditCardAtDoor", 'Credit Card'), _define_property(_obj, "payOnlineHypur", 'Hypur'), _define_property(_obj, "payOnlineMerrco", 'Credit Card'), _define_property(_obj, "payOnlineMoneris", 'Credit Card'), _define_property(_obj, "payOnlineChase", 'Credit Card'), _define_property(_obj, "creditCardByPhone", 'Pay by Phone'), _define_property(_obj, "inStoreCreditCard", 'Credit Card'), _define_property(_obj, "credit", 'Credit Card'), _define_property(_obj, "debitCard", 'Debit Card'), _define_property(_obj, "debitOnly", 'Debit Card'), _define_property(_obj, "debit", 'Debit Card'), _define_property(_obj, "dutchiePay", 'Pay by Bank'), _define_property(_obj, "rethinkPay", 'ReThink Wallet'), _define_property(_obj, "linx", 'Linx'), _define_property(_obj, "alt36", 'Alt Thirty Six'), _define_property(_obj, "canPay", 'CanPay'), _define_property(_obj, "paytender", 'Paytender'), _define_property(_obj, "aeropay", 'Aeropay'), _obj);
export var orderTypesToDisplayNames = {
    inStorePickup: 'In-Store Pickup',
    curbsidePickup: 'Curbside Pickup',
    driveThruPickup: 'Drive-Thru Pickup',
    delivery: 'Delivery',
    kiosk: 'Kiosk'
};
export var orderTypesToShortNamesV2 = {
    inStorePickup: 'In-Store',
    curbsidePickup: 'Curbside',
    driveThruPickup: 'Drive-Thru',
    delivery: 'Delivery'
};
export var paysafeCardTypes = {
    VI: 'Visa',
    MC: 'Mastercard',
    MD: 'Mastercard',
    AM: 'Amex',
    DI: 'Discover'
};
export var paymentMethodsToDisplayNamesAdmin = _object_spread_props(_object_spread({}, paymentMethodsToDisplayNames), {
    payOnlineMerrco: 'Credit Card (Merrco)',
    payOnlineMoneris: 'Credit Card (Moneris)',
    payOnlineChase: 'Credit Card (Chase)',
    dutchiePay: 'Pay by Bank',
    rethinkPay: 'ReThink Wallet'
});
export var validOrderTypes = Object.keys(orderTypesToDisplayNames);
export var firstValidPaymentOption = function() {
    var dispensary = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {};
    if (!dispensary.cashless) {
        return 'cash';
    }
    if (dispensary.payOnlineMerrco) {
        return 'creditCard';
    }
    var foundMethod = _.find(_.keys(paymentMethodsToDisplayNames), function(key) {
        return dispensary[key];
    }) || _.keys(paymentMethodsToDisplayNames)[0];
    return foundMethod;
};
export var defaultDurationEstimates = {
    delivery: {
        lowInMinutes: 35,
        highInMinutes: 45
    },
    pickup: {
        lowInMinutes: 15,
        highInMinutes: 25
    },
    curbsidePickup: {
        lowInMinutes: 15,
        highInMinutes: 25
    }
};
export var defaultActionEstimates = {
    pickup: {
        readyInMinutes: 20,
        rangeInMinutes: 5
    },
    delivery: {
        readyInMinutes: 25,
        rangeInMinutes: 10,
        deliveryTimeInMinutes: 20
    }
};
// valid id's enum - graphql/order/type.js
export var archiveReasons = function() {
    var _ref = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : {}, _ref_phone = _ref.phone, phone = _ref_phone === void 0 ? '' : _ref_phone, _ref_orderId = _ref.orderId, orderId = _ref_orderId === void 0 ? '' : _ref_orderId;
    return [
        {
            id: 'NOPICKUP',
            reason: 'Customer never picked up the order',
            customerMessage: "Your order #".concat(orderId, " was canceled because it wasn't picked up. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'SOLDOUT',
            reason: 'Items on the order were sold out',
            customerMessage: "Your order #".concat(orderId, " contained a sold-out item and has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'CANCELLED',
            reason: 'Customer asked to cancel the order',
            customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'NOPAYMENT',
            reason: 'Customer didn’t have proper payment',
            customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'NOIDENTIFICATION',
            reason: 'Customer didn’t have proper identification',
            customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'BADINFO',
            reason: 'Customer entered their information incorrectly',
            customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'COMPLIANCEVIOLATION',
            reason: 'The order violated compliance',
            customerMessage: "Your order #".concat(orderId, " has been canceled for compliance reasons. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        },
        {
            id: 'OTHER',
            reason: 'Other',
            customerMessage: "Your order #".concat(orderId, " has been canceled. Please contact ").concat(phone, " if you have questions or believe this was a mistake.")
        }
    ];
};
export var orderTypeToIndex = {
    pickup: 0,
    delivery: 1
};
export var ORDER_TYPE_DELIVERY = 'delivery';
export var ORDER_TYPE_PICKUP = 'pickup';
export var indexToOrderType = [
    ORDER_TYPE_PICKUP,
    ORDER_TYPE_DELIVERY
];
export var RewardsConnectionStatuses = {
    ready: 'ready',
    processing: 'processing',
    failed: 'failed',
    succeeded: 'succeeded'
};
export var RewardsBrands = {
    alpineiq: 'alpineiq'
};
export var CHECKOUT_LINE_ITEM_MAPPING = {
    subtotal: 'productSubtotal',
    taxes: 'totalTax',
    discounts: 'discount',
    rewards: 'reward',
    bottleDeposit: 'bottleDepositTaxCents',
    sales: 'salesTax',
    cannabis: 'cannabisTax',
    delivery: 'deliveryFee',
    payment: 'paymentFee',
    other: 'otherFees'
};
